var map = {
	"./card_lx_donations.png": 91091,
	"./card_lx_faces.png": 42940,
	"./card_lx_globe.png": 87084,
	"./card_lx_thanks.png": 90047,
	"./card_lx_wheelchair.png": 63328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61042;